import { CheckCircle, Calendar, ArrowRight, Sparkles } from 'lucide-react';

interface QualifiedStepProps {
  bookingMessage?: string;
  bookingUrl: string;
  onBookCall: () => void;
}

export default function QualifiedStep({
  bookingMessage,
  bookingUrl,
  onBookCall,
}: QualifiedStepProps) {
  const handleBookCall = () => {
    if (bookingUrl) {
      window.open(bookingUrl, '_blank');
    }
    onBookCall();
  };

  return (
    <div className="text-center py-8">
      {/* Animated icon */}
      <div className="relative inline-flex items-center justify-center mb-8">
        <div className="absolute inset-0 w-24 h-24 rounded-full bg-emerald-500/20 animate-ping [animation-duration:2s]" />
        <div className="relative w-24 h-24 rounded-full bg-emerald-500/20 flex items-center justify-center">
          <CheckCircle className="w-12 h-12 text-emerald-400" />
        </div>
      </div>

      {/* Heading with sparkle */}
      <h2 className="text-3xl font-bold text-white flex items-center justify-center gap-3">
        <Sparkles className="w-6 h-6 text-amber-400" />
        Let's talk!
        <Sparkles className="w-6 h-6 text-amber-400" />
      </h2>

      <p className="text-slate-300 mt-4 max-w-md mx-auto text-lg leading-relaxed">
        {bookingMessage ||
          "Based on your project details, we think we'd be a great fit. Let's schedule a quick intro call to discuss your vision."}
      </p>

      {/* CTA button */}
      <button
        type="button"
        onClick={handleBookCall}
        className="mt-8 inline-flex items-center gap-3 rounded-xl bg-emerald-500 px-8 py-4 text-lg font-semibold text-white shadow-lg shadow-emerald-500/25 transition-all hover:bg-emerald-400 hover:shadow-emerald-500/40 hover:scale-[1.02] active:scale-[0.98]"
      >
        <Calendar className="w-5 h-5" />
        Schedule Intro Call
        <ArrowRight className="w-5 h-5" />
      </button>

      <p className="text-sm text-slate-400 mt-4">
        30 minutes &middot; No obligation &middot; Video or phone
      </p>

      <div className="mt-8 pt-6 border-t border-slate-700/50">
        <p className="text-sm text-slate-500">
          Prefer email? We'll also send you a confirmation with next steps.
        </p>
      </div>
    </div>
  );
}
